// Multi-manager buyer teams — team-owned prequalification sites.
//
// This mounts the SHARED PrequalificationSiteTab rather than reimplementing
// anything: that component is already parameterised by owner kind and serves the
// broker and brokerage detail pages from the same code. Reusing it is what keeps
// "which site belongs to this owner" a single answer — a second read here would
// be free to disagree with the one the partner surfaces give.
//
// 🔴 A team's site is MINTED WITH THE TEAM and managed automatically (D2a): it
// carries the Phoenix skin, the server refuses edit / unpublish / delete for it,
// and the shared tab renders it read-only for everyone — so nobody, whatever
// they hold, sees a button that would 400. What the tab does offer is the two
// public links and every advertisement's own landing link, each with Copy.

import type { BuyerTeamDetailDto } from "@/api/buyerTeams";
import { PrequalificationSiteTab } from "@/components/partners/PrequalificationSiteTab";

export function IntakeSitesTab({ team }: { team: BuyerTeamDetailDto }) {
  return (
    <div data-testid="buyer-team-intake-sites-tab">
      <PrequalificationSiteTab owner={{ kind: "buyerTeam", id: team.id, name: team.name }} />
    </div>
  );
}
